import {
  Box,
  Button,
  Grid,
  VStack,
  chakra,
  Skeleton,
  Text,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure,
  ModalCloseButton,
  Image,
} from '@chakra-ui/react';

import Clinico from '../../../../../../images/dashboard/clinico.svg';
import Pediatra from '../../../../../../images/dashboard/pediatra.svg';
import Veterinario from '../../../../../../images/dashboard/veterinario.svg';
import useModelCardsTelemedicina from './useModelCardsTelemedicina';
import Logo from '../../../../../../images/petalas-deovita.svg';
import React, { useState } from 'react';

import vetorNegativo from '../../../../../../images/assets/telemedicina/vetorNegativo.svg';
import vetorPositivo from '../../../../../../images/assets/telemedicina/vetorPositivo.svg';

function CardsTelemedicina({ prontoAtendimento, error, loading, gratuito }) {
  const { navigate, assinante, logado, setUser, toast, user, telepet, loadingPet, handleTelepet } = useModelCardsTelemedicina();
  const [imgLoaded, setImgLoaded] = useState({ clinico: false, pediatra: false, veterinario: false });
  const disclosure = useDisclosure();
  const [tipoAtendimento, setTipoAtendimento] = useState(null);
  const loadingGenerico = () => {
    return (
      <>
        <Modal isOpen={loadingPet} onClose={loadingPet} isCentered>
          <ModalOverlay />
          <ModalContent height="180px" width="280px" borderRadius="1em">
            <ModalBody>
              <VStack w="100%" alignItems="center">
                <img src={Logo} style={{ marginTop: '2em', width: '36px' }} className="rotate" alt="Loading..." />
              </VStack>
              <Text ml="3" mt="15" color={'#585858'} fontSize={'18px'}>
                Estamos carregando as informações, aguarde <b style={{ color: '#2A918A' }}>...</b>
              </Text>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    );
  };
  return (
    <>
      {loadingGenerico()}
      <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose} isCentered>
        <ModalOverlay />
        <ModalContent maxW="90%" h="auto" borderRadius="0.8em" p={4}>
          <ModalCloseButton />
          <ModalBody width={'100%'} p={0} m={0}>
            <VStack width={'100%'} spacing={4} p={0} m={0}>
              <Text color="#616161" fontWeight="bold" fontSize="1.2em" textAlign="center">
                Consulta por um preço <br /> que cabe no bolso!
              </Text>
              <Text
                display="flex"
                alignItems="center"
                gap={2}
                color="white"
                fontWeight="semibold"
                fontSize="1em"
                textAlign="center"
                bg="#5AB2AE"
                borderRadius="full"
                p={1}
              >
                <Image src={vetorPositivo} alt="Com plano" boxSize="16px" />
                Com plano
              </Text>

              <Text color="#5AB2AE" fontSize="3xl" textAlign="center" fontWeight={'bold'}>
                R${' '}
                {!error
                  ? tipoAtendimento === 'clinico'
                    ? prontoAtendimento?.valor_clinico_assinante != null
                      ? Number(prontoAtendimento.valor_clinico_assinante).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                      : '!'
                    : tipoAtendimento === 'pediatra'
                      ? prontoAtendimento?.valor_pediatra_assinante != null
                        ? Number(prontoAtendimento.valor_pediatra_assinante).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                        : '!'
                      : tipoAtendimento === 'veterinario'
                        ? prontoAtendimento?.valor_veterinario_assinante != null
                          ? Number(prontoAtendimento.valor_veterinario_assinante).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                          : '!'
                        : '!'
                  : null}
              </Text>

              <HStack>
                <Text
                  display="flex"
                  alignItems="center"
                  gap={2}
                  color="#D62422"
                  fontWeight="semibold"
                  fontSize="1em"
                  textAlign="center"
                  bg="linear-gradient(180deg, rgba(214, 36, 34, 0.1) 0%, rgba(186, 5, 12, 0.1) 100%)"
                  borderRadius="full"
                  p={1}
                >
                  <Image src={vetorNegativo} alt="Sem plano" boxSize="16px" />
                  Sem plano
                </Text>

                <Text color="#5AB2AE" fontSize="2xl" textAlign="center" fontWeight={'bold'}>
                  R${' '}
                  {!error
                    ? tipoAtendimento === 'clinico'
                      ? prontoAtendimento?.valor_clinico_assinante != null
                        ? Number(prontoAtendimento.valor_clinico).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                        : '!'
                      : tipoAtendimento === 'pediatra'
                        ? prontoAtendimento?.valor_pediatra_assinante != null
                          ? Number(prontoAtendimento.valor_pediatra).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                          : '!'
                        : tipoAtendimento === 'veterinario'
                          ? prontoAtendimento?.valor_veterinario_assinante != null
                            ? Number(prontoAtendimento.valor_veterinario).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                            : '!'
                          : '!'
                    : null}
                </Text>
              </HStack>

              <Text textAlign={'center'} color="#616161" fontWeight={'bold'}>
                {' '}
                <span style={{ color: '#5AB2AE' }}>Economize</span> mais de
                <span style={{ color: '#5AB2AE' }}>
                  {' '}
                  R${' '}
                  {tipoAtendimento === 'clinico'
                    ? prontoAtendimento?.valor_clinico - prontoAtendimento?.valor_clinico_assinante
                    : tipoAtendimento === 'pediatra'
                      ? prontoAtendimento?.valor_pediatra - prontoAtendimento?.valor_pediatra_assinante
                      : tipoAtendimento === 'veterinario'
                        ? prontoAtendimento?.valor_veterinario - prontoAtendimento?.valor_veterinario_assinante
                        : 0}{' '}
                </span>
                na sua consulta usando o <span style={{ color: '#5AB2AE' }}>plano DeoVita</span>
              </Text>

              <Button
                bg="#5AB2AE"
                color="white"
                px={6}
                py={3}
                borderRadius="full"
                w="100%"
                onClick={() => {
                  navigate('/pagamento-telemedicina', {
                    state: { tipoAtendimento: tipoAtendimento, telemedicina: true },
                  });
                }}
              >
                Veja como funciona!
              </Button>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Grid templateColumns={{ base: '1fr 1fr 1fr', sm: 'repeat(3, 1fr)' }} gap={2.5} width="100%" maxWidth="900px" mx="auto" marginBottom={5}>
        <Button
          bg="white"
          color="#616161"
          p={6}
          borderRadius="1em"
          minW={0}
          h={{ base: '120px', md: '140px', lg: '150px' }}
          boxShadow="lg"
          _focus={false}
          onClick={async () => {
            if (error || prontoAtendimento?.valor_clinico === undefined || prontoAtendimento?.valor_clinico === null) {
              return;
            }

            if (gratuito || prontoAtendimento?.valor_clinico === 0) {
              setUser((prevUser) => ({
                ...prevUser,
                paga_telemedicina: false,
              }));
              navigate('/aviso-pre-atendimento/', {
                state: { titulo: 'Pronto Atendimento', tela: '/medico-agora/', pediatra: false },
              });
              return;
            }
            setTipoAtendimento('clinico');

            if (!assinante) {
              disclosure.onOpen();
              return;
            }

            navigate('/pagamento-telemedicina', {
              state: { tipoAtendimento: 'clinico', telemedicina: true },
            });
          }}
        >
          <VStack spacing={1} align="center" width="100%">
            <Box position="relative" width="fit-content" mx="auto" height="56px">
              <chakra.h1
                bg="#2A918A"
                color={'white'}
                borderRadius="full"
                px={{ base: 2, md: 3 }}
                py={{ base: 1, md: 2 }}
                fontSize={{ base: 'xs', md: 'sm' }}
                minW={{ base: '32px', md: '48px' }}
                textAlign="center"
                position="absolute"
                left={{ base: '-18px', md: '-18px' }}
                top={{ base: '-18px', md: '-16px' }}
                boxShadow="md"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                24h
              </chakra.h1>
              <Skeleton isLoaded={imgLoaded.clinico} borderRadius="full" width="50px" height="50px">
                <img
                  src={Clinico}
                  alt="Clínico Geral 24h"
                  style={{ width: '50px', height: '50px', position: 'relative', borderRadius: '50%' }}
                  onLoad={() => setImgLoaded((prev) => ({ ...prev, clinico: true }))}
                />
              </Skeleton>
            </Box>
            <chakra.span fontWeight="semibold" fontSize="sm">
              Clínico Geral
            </chakra.span>
            <Skeleton isLoaded={!loading} width="60px" height="20px" borderRadius="md">
              <HStack justifyContent="center">
                <chakra.span fontSize="xs" color={!error || (!error && !prontoAtendimento?.faltou) ? '#616161' : 'red.600'}>
                  R${' '}
                  {!error && prontoAtendimento?.valor_clinico !== undefined && prontoAtendimento?.valor_clinico !== null
                    ? assinante
                      ? Number(prontoAtendimento.valor_clinico).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                      : Number(prontoAtendimento.valor_clinico_assinante).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                    : '!'}
                </chakra.span>
              </HStack>
            </Skeleton>
          </VStack>
        </Button>

        <Button
          bg="white"
          color="#616161"
          p={6}
          borderRadius="1em"
          minW={0}
          h={{ base: '120px', md: '140px', lg: '150px' }}
          boxShadow="lg"
          _focus={false}
          onClick={async () => {
            if (error || prontoAtendimento?.valor_pediatra === undefined || prontoAtendimento?.valor_pediatra === null) {
              return;
            }

            if (gratuito || prontoAtendimento?.valor_pediatra === 0) {
              setUser((prevUser) => ({
                ...prevUser,
                paga_telemedicina: false,
              }));
              navigate('/aviso-pre-atendimento/', {
                state: {
                  titulo: 'Pronto Atendimento Pediátrico',
                  tela: '/medico-agora/',
                  pediatra: true,
                },
              });
              return;
            }
            setTipoAtendimento('pediatra');
            if (!assinante) {
              disclosure.onOpen();
              return;
            }
            navigate('/pagamento-telemedicina', {
              state: { tipoAtendimento: 'pediatra', telemedicina: true },
            });
          }}
        >
          <VStack spacing={1} align="center" width="100%">
            <Box position="relative" width="fit-content" mx="auto" height="56px">
              <chakra.h1
                bg="#2A918A"
                color={'white'}
                borderRadius="full"
                px={{ base: 2, md: 3 }}
                py={{ base: 1, md: 2 }}
                fontSize={{ base: 'xs', md: 'sm' }}
                minW={{ base: '32px', md: '48px' }}
                textAlign="center"
                position="absolute"
                left={{ base: '-18px', md: '-18px' }}
                top={{ base: '-18px', md: '-16px' }}
                boxShadow="md"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                24h
              </chakra.h1>
              <Skeleton isLoaded={imgLoaded.pediatra} borderRadius="full" width="50px" height="50px">
                <img
                  src={Pediatra}
                  alt="Pediatria 24h"
                  style={{ width: '50px', height: '50px', position: 'relative', borderRadius: '50%' }}
                  onLoad={() => setImgLoaded((prev) => ({ ...prev, pediatra: true }))}
                />
              </Skeleton>
            </Box>
            <chakra.span fontWeight="semibold" fontSize="sm">
              Pediatria
            </chakra.span>

            <Skeleton isLoaded={!loading} width="60px" height="20px" borderRadius="md">
              <HStack justifyContent="center">
                <chakra.span fontSize="xs" color={!error || (!error && !prontoAtendimento?.faltou) ? '#616161' : 'red.600'}>
                  R${' '}
                  {!error && prontoAtendimento?.valor_pediatra !== undefined && prontoAtendimento?.valor_pediatra !== null
                    ? assinante
                      ? Number(prontoAtendimento.valor_pediatra).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                      : Number(prontoAtendimento.valor_pediatra_assinante).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                    : '!'}
                </chakra.span>
              </HStack>
            </Skeleton>
          </VStack>
        </Button>

        <Button
          bg="white"
          color="#616161"
          p={6}
          minW={0}
          h={{ base: '120px', md: '140px', lg: '150px' }}
          boxShadow="lg"
          borderRadius="1em"
          _focus={false}
          onClick={async () => {
            setTipoAtendimento('veterinario');
            if (!assinante) {
              disclosure.onOpen();
              return;
            }
            if (!user.loggedIn) {
              navigate('/pagamento-telemedicina', {
                state: { tipoAtendimento: 'veterinario', telemedicina: true },
              });
              return;
            }

            if (!user.titular) {
              toast({
                render: () => (
                  <Box color="white" bg="#5AB2AE" p={3} borderRadius="md">
                    <Text fontWeight="bold">Importante</Text>
                    <Text>Este serviço está disponível apenas para titulares.</Text>
                  </Box>
                ),
                duration: 3000,
                isClosable: true,
                position: 'bottom',
                containerStyle: {
                  paddingBottom: '5em',
                },
              });
              return;
            }

            await handleTelepet(gratuito, prontoAtendimento?.valor_veterinario, disclosure);
          }}
        >
          <VStack spacing={1} align="center" width="100%">
            <Skeleton isLoaded={imgLoaded.veterinario} borderRadius="full" width="50px" height="50px">
              <img
                src={Veterinario}
                alt="Veterinário"
                style={{ width: '50px', height: '50px', position: 'relative', borderRadius: '50%' }}
                onLoad={() => setImgLoaded((prev) => ({ ...prev, veterinario: true }))}
              />
            </Skeleton>
            <chakra.span fontWeight="semibold" fontSize="sm">
              Veterinário
            </chakra.span>
            <Skeleton isLoaded={!loading} width="60px" height="20px" borderRadius="md">
              <HStack justifyContent="center">
                <chakra.span fontSize="xs" color={!error || (!error && !prontoAtendimento?.faltou) ? '#616161' : 'red.600'}>
                  R${' '}
                  {!error && prontoAtendimento?.valor_veterinario !== undefined && prontoAtendimento?.valor_veterinario !== null
                    ? assinante
                      ? Number(prontoAtendimento.valor_veterinario).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                      : Number(prontoAtendimento.valor_veterinario_assinante).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                    : '!'}
                </chakra.span>
              </HStack>
            </Skeleton>
          </VStack>
        </Button>
      </Grid>
      {assinante && prontoAtendimento?.faltou && (
        <>
          <Box
            align="left"
            borderRadius="0.8em"
            p={4}
            shadow="sm"
            w="100%"
            border="1px solid #FFCBCF"
            bg="linear-gradient(90deg, #FFEAED 0%, #FFEAED 100%)"
            o
            style={{
              boxShadow: '0 0 5px rgba(255, 203, 207, 0.5)',
            }}
          >
            <VStack align="center" spacing={0}>
              <Text fontWeight="bold" fontSize="1.2em" color="#D62422">
                Importante!
              </Text>
              <Text color="#D62422" fontSize="sm" mt={1}>
                O valor cobrado refere-se a uma multa de 50% do valor da consulta, aplicada por faltas em atendimentos anteriores no período de 60
                dias.
              </Text>
            </VStack>
          </Box>
        </>
      )}
    </>
  );
}

export default CardsTelemedicina;
